/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */


import { PointOnMap } from './point-on-map';

export class DeliveryAddress {
  formattedAddress: string = null;
  userAddressDetails: string = null;
  addressLine1: string = null;
  addressLine2: string = null;
  area: string = null;
  city: string = null;
  state: string = null;
  country: string = null;
  zip: string = null;
  geoPoint: PointOnMap = new PointOnMap();
  note: string = null;
  placeName: string = null;
  addressType: string = null;
  googlePlaceId: string = null;
}



// WEBPACK FOOTER //
// ./src/app/models/delivery-address.ts